import { ReactNode } from "react";
import { Alert } from "@zapier/design-system";
import { ProgressBar } from "../ProgressBar";
import styles from "./BannerWrapperV2.module.css";
import { UpgradeAlert } from "../UpgradeAlert/UpgradeAlert";

type Props = {
  alert?: string;
  children?: ReactNode;
  showProgress?: boolean;
};

export function BannerWrapperV2({
  alert,
  children,
  showProgress = false,
}: Props) {
  return (
    <div className={styles.wrapper}>
      <Alert variant="banner">
        <div className={styles.buttonsWrapper}>{children}</div>
      </Alert>
      {showProgress && (
        <div className={styles.progressBarWrapper}>
          <ProgressBar />
        </div>
      )}
      {alert && <UpgradeAlert title={alert} />}
    </div>
  );
}
